/* eslint-disable no-unused-vars */
import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import addUidToObject from '../utilities/addUidToObject'
import getISOFormattedTimestamp from '../utilities/getISOFormattedTimestamp'

//  Ref: from uxlytics
const getBrowserDetails = () => {
	const date = new Date()
	return {
		url: global.location.href,
		useragent: global.navigator.userAgent,
		referrer: global.document.referrer,
		timestamp: date.getTime(),
		timezone: date.toTimeString(),
		screen: `${global.screen.width}x${global.screen.height}x${global.screen.colorDepth}`,
		viewport: `${global.innerWidth}x${global.innerHeight}`,
		devicepixelratio: `x${global.devicePixelRatio}`,
		language: (global.document.userLanguage || global.document.language || global.navigator.language || global.navigator.browserLanguage).substring(0, 2)
	}
}

//	Removes PII for GDPR compliance, in case the store is passed through as data
const cleanData = (data) => {
	const newStore = Object.assign({}, data)
	delete newStore.user
	delete newStore.userProfile
	return newStore
}

const createLogEntry = (action = 'UNKNOWNACTION', data = {}, details = {}, type = 'REDUX') => Object.assign({
	action,
	data: cleanData(data),
	type,
	url: global.location.href,
	timestamp: (new Date()).getTime(),
	date: getISOFormattedTimestamp(),
	browser: getBrowserDetails(),
	requiresNotification: true
}, details)

const addAppErrorLogEntry = (action, data, details, type) => {
	const entry = addUidToObject(createLogEntry(action, data, details, type))
	return entry.uid ? firestore.collection('appErrorLogs').add(JSON.parse(JSON.stringify(entry)))
		.catch(exception => Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, entry, exception))) : undefined
}
export default addAppErrorLogEntry



// WEBPACK FOOTER //
// ./src/dataservices/addAppErrorLogEntry.js